import { supabase } from '@/integrations/supabase/client';
import type { Conversation } from '@/shared/hooks/useConversations';

export const conversationsRepository = {
  async getUnreadCount(): Promise<number> {
    const { data, error } = await supabase.rpc('get_unread_messages_count');
    if (error) throw error;
    return typeof data === 'number' ? data : 0;
  },

  async getConversations(): Promise<Conversation[]> {
    const { data, error } = await supabase.rpc('get_conversations');
    if (error) throw error;
    return Array.isArray(data) ? (data as Conversation[]) : [];
  },

  async createOrGetConversation(otherUserId: string): Promise<string> {
    const { data, error } = await supabase.rpc('create_or_get_conversation', {
      p_other_user_id: otherUserId,
    });
    if (error) throw error;
    return data as string;
  },
};
